import { light as dtLight } from '@themenu/design-tokens-react';
export const light = dtLight;
